const $popup = $('.js-popup');

const SAVE_FOR_DAYS = 1;

const cookieBar = {
  initialize() {
    if ($popup.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $popup.modal('show');

    $popup.on('hidden.bs.modal', () => {
      this.popupShown();
    });
  },

  /**
   * Saves a cookie with the given data
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   * @return {void}
   */
  setCookie(name, value, days) {
    let expires = '';

    const HOURS_DAY = 24;
    const MINUTES_HOUR = 60;
    const SECONDS_MINUTE = 60;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * HOURS_DAY * MINUTES_HOUR * SECONDS_MINUTE * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },

  /**
   * The user accepted cookies, Yay!
   * @return {void}
   */
  popupShown() {
    this.setCookie(`popup_seen_${$popup.data('popup-id')}`, 1, SAVE_FOR_DAYS);
  },
};

export default cookieBar;
